import { getPaises, getProvincias, getRegimenes } from '../../../utils/modalDataUtils';

// Simple text display component
const TextDisplay = ({ value, className = "" }) => {
  const displayValue = value === null || value === undefined || value === '' ? 'null' : value;
  return (
    <p className={`${className} py-1`}>{displayValue}</p>
  );
};

export const ItemInformation = ({
  declarationIndex,
  itemIndex,
  isSpanish,
  item,
  editableData,
  setEditableData,
  setIsDirty,
}) => {
  const paises = getPaises();
  const regimenes = getRegimenes();
  const provincias = getProvincias();
  const selectedPaisOrigen = paises.find(
    (p) => p.codigo === item.pais_origen || p.nombre === item.pais_origen
  );
  const selectedRegimen = regimenes.find(
    (r) => r.codigo === item.regimen_solicitado_precedente || r.nombre === item.regimen_solicitado_precedente
  );
  const selectedProvincia = provincias.find(
    (p) => p.codigo === item.provincia_origen || p.nombre === item.provincia_origen
  );

  return (
    <div>
      <div className="flex items-center justify-between mb-4">
        <h2 className="text-2xl font-semibold uppercase">
          {!isSpanish ? "Item" : "Partida"} #{itemIndex + 1}
        </h2>
        {/* <button
          className="py-1 text-xs text-red-500 flex items-center gap-1"
          onClick={() => {
            const updatedData = [...editableData];
            updatedData[declarationIndex].partidas.splice(itemIndex, 1);
            setEditableData(updatedData);
            setIsDirty(true);
          }}
        >
          <Trash className={`size-4 stroke-red-500`} />
          {!isSpanish ? "Remove Item" : "Eliminar Partida"}
        </button> */}
      </div>
      <div className="form-group flex-1 ">
        <label
          htmlFor="descripcion_mercancia"
          className={`${!item.descripcion_mercancia && "text-red-600"}`}
        >
          {!isSpanish ? "Goods Description" : "Descripción de Mercancía"}
        </label>
        <TextDisplay value={item.descripcion_mercancia} />
      </div>
      <div className="grid grid-cols-3 gap-8 rounded-md mt-4 partida-container">
        <div className="form-group">
          <label
            htmlFor="codigo_nc"
            className={`${!item.codigo_nc && "text-red-600"}`}
          >
            {!isSpanish ? "NC Code" : "Código NC"}
          </label>
          <TextDisplay value={item.codigo_nc} />
        </div>
        <div className="form-group">
          <label
            htmlFor="masa_bruta"
            className={`${!item.masa_bruta && "text-red-600"}`}
          >
            {!isSpanish ? "Gross Weight" : "Masa Bruta"}
          </label>
          <TextDisplay value={item.masa_bruta} />
        </div>
        <div className="form-group">
          <label
            htmlFor="masa_neta"
            className={`${!item.masa_neta && "text-red-600"}`}
          >
            {!isSpanish ? "Net Weight" : "Masa Neta"}
          </label>
          <TextDisplay value={item.masa_neta} />
        </div>
        <div className="form-group">
          <label
            htmlFor="cantidad_euros"
          >
            {!isSpanish ? "Euro Amount" : "Cantidad en Euros"}
          </label>
          <TextDisplay value={item.cantidad_euros} />
        </div>
        <div className="form-group">
          <label
            htmlFor="pais_origen"
            className={`${!item.pais_origen && "text-red-600"}`}
          >
            {!isSpanish ? "Country of Origin" : "País de Origen"}
          </label>
          <TextDisplay
            value={selectedPaisOrigen
              ? `${selectedPaisOrigen.codigo}${selectedPaisOrigen.nombre ? ` (${selectedPaisOrigen.nombre})` : ''}`
              : item.pais_origen
            }
          />
        </div>
        <div className="form-group">
          <label
            htmlFor="precio"
          >
            {!isSpanish ? "Price" : "Precio"}
          </label>
          <TextDisplay value={item.precio} />
        </div>
        <div className="form-group">
          <label
            htmlFor="provincia_origen"
          >
            {!isSpanish ? "Province of Origin" : "Provincia de Origen"}
          </label>
          <TextDisplay
            value={selectedProvincia
              ? `${selectedProvincia.codigo}${selectedProvincia.nombre ? ` (${selectedProvincia.nombre})` : ''}`
              : item.provincia_origen
            }
          />
        </div>
        <div className="form-group">
          <label
            htmlFor="regimen_solicitado_precedente"
            className={`truncate`}
          >
            {!isSpanish ? "Previous Regime" : "Régimen Solicitado"}
          </label>
          <TextDisplay
            value={selectedRegimen
              ? `${selectedRegimen.codigo}${selectedRegimen.nombre ? ` (${selectedRegimen.nombre})` : ''}`
              : item.regimen_solicitado_precedente
            }
          />
        </div>
        <div className="form-group">
          <label
            htmlFor="valor_estadistico"
          >
            {!isSpanish ? "Statistical Value" : "Valor Estadístico"}
          </label>
          <TextDisplay value={item.valor_estadistico} />
        </div>
      </div>
    </div>
  );
};
